import { useState } from "react";

import {
  AtsIntegration,
  LeverIntegrationContext,
  TriggerStage,
} from "./LeverIntegrationContext";
import { ApiKeyStep } from "./components/steps/ApiKeyStep";
import { FurtherDetailsStep } from "./components/steps/FurtherDetailsStep";

export function LeverIntegrationSetupPage() {
  const [atsIntegrationData, setAtsIntegration] = useState<AtsIntegration>({
    api_key: "",
    webhook_signature_token: "",
    report_url_type: "DIRECT_PDF_URL",
    default_package_id: "",
    customer_group_id: "",
    trigger_stage_id: "",
  });
  const [currentStep, setCurrentStep] = useState(0);
  const [triggerStages, setTriggerStages] = useState<Array<TriggerStage>>([]);

  const steps = [
    <ApiKeyStep key="ApiKeyStep" />,
    <FurtherDetailsStep key="FurtherDetailsStep" />,
  ];

  const goToNextStep = () => setCurrentStep((curr) => curr + 1);
  const goToPrevStep = () => setCurrentStep((curr) => curr - 1);

  return (
    <LeverIntegrationContext.Provider
      value={{
        atsIntegrationData,
        setAtsIntegration,
        goToNextStep,
        goToPrevStep,
        currentStep,
        triggerStages,
        setTriggerStages,
      }}
    >
      {steps[currentStep]}
    </LeverIntegrationContext.Provider>
  );
}
